import React from 'react'
import '../css/about.css'

export default function About() {
  return (
    <div className='background'>
      <h1>Hit After Hit Records</h1>

      <div className='row'>
        <div className='col-md'>
          <h3>About Us</h3>

          <p>
            Hit After Hit Records is a music and video production studio based in
            the heart of <b>Gwano Location</b>, at <b>Wenje Centre, Tana River County</b>.
          </p>

          <p>
            Born out of a passion for music on <b>Friday, 5 February 2021</b>, in
            <b> Hola Town</b>, Hit After Hit Records was later relocated to Wenje Centre,
            a more centrally located area within the county.
          </p>

          <div className='highlight-box'>
            <p>
              <b>Our Main Objective:</b> To produce music that is not only loved
              by fans but also deeply cherished by our audience. We are committed
              to creating music that resonates with our listeners and leaves a
              lasting impact, while remaining grateful for the incredible support
              we have received throughout our journey.
            </p>
          </div>

          <p>
            While we are committed to creating great music, we also believe in
            producing music with meaning and a message. Whatever your story,
            emotions, or inspiration, we strive to bring it to life through music.
          </p>

          <h3>🎯 Motivation</h3>

          <p>
            We believe there is immense untapped talent among the people of
            Tana River County. There are many talented artists with the potential
            to make a significant impact, but they often lack access to modern
            equipment and professional production facilities needed to take their
            music to the next level.
          </p>

          <p>
            Our goal is to bridge this gap by providing accessible, modern
            production facilities and creating an environment where local talent
            can grow, develop, and showcase its potential. Through this,
            we hope to become ambassadors of positive change in the local music
            industry.
          </p>

          <h3>🌟 Vision</h3>

          <p>
            To be a beacon of innovative music and video production in
            Tana River County and across Kenya.
          </p>

          <h3>💼 Mission</h3>

          <p>
            To produce high-quality music and visual content that resonates with
            audiences and earns appreciation both locally and globally.
          </p>
        </div>
      </div>
    </div>
  )
}